module.exports = __webpack_public_path__ + "img/university_5.a4ce9f22.png";